import React, { useEffect } from 'react';

const BASE_URL = 'https://8080.ai';
const DEFAULT_TITLE = '8080.AI - Build with Scalable AI Agents';

interface PageMetaProps {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
}

const setMeta = (attr: string, key: string, content: string) => {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.querySelector(selector);

  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href: string) => {
  let el = document.querySelector('link[rel="canonical"]');

  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const applyOg = (title: string, description: string, url: string, ogImage?: string) => {
  setMeta('property', 'og:title', title);
  setMeta('property', 'og:description', description);
  setMeta('property', 'og:url', url);
  if (ogImage) setMeta('property', 'og:image', ogImage);
  setMeta('name', 'twitter:title', title);
  setMeta('name', 'twitter:description', description);
};

export const PageMeta: React.FC<PageMetaProps> = ({ title, description, path, ogImage }) => {
  useEffect(() => {
    const url = `${BASE_URL}${path}`;

    document.title = title;
    setMeta('name', 'description', description);
    applyOg(title, description, url, ogImage);
    setCanonical(url);

    return () => { document.title = DEFAULT_TITLE; };
  }, [title, description, path, ogImage]);

  return null;
};
